import { Chip } from "@mui/material";

import useQuoteClassifications from "helpers/context/SelectionValues/useQuoteClassifications";
import { OrderStatusDescriptionEnum, OrderStatusEnum, RoleEnum, ThemeColorEnum } from "helpers/enums";
import useQuoteData from "components/Quotes/useQuoteData";
import { useMemo } from "react";
import { useTranslations } from "@fenetech/translations";
import Constants from "helpers/constants";
import useUserInfo from "helpers/context/User/useUserInfo";
import { isNullOrWhiteSpace } from "helpers/objects";

function StatusChip() {

    const tm = useTranslations();
    const quoteClassifications = useQuoteClassifications();
    const { quote } = useQuoteData();
    const user = useUserInfo();

    const isContractor = useMemo(() => {
        return user.HasRole(RoleEnum.Contractor);
    }, [user]);

    const [chipLabel, chipColor]: [string, ThemeColorEnum] = useMemo(() => {
        if (quote?.classificationID !== undefined && quote?.status !== undefined && quoteClassifications) {
            const classificationDescription = quoteClassifications.GetQuoteClassificationDescription(quote.classificationID, quote.status);

            // Contractor viewing their submitted quote that goes to the dealer
            if (isContractor && quote.contractorOrderNumber) {
                //Mimic the status column for the submitted quotes dashboard, available & uploaded mean different things to a contractor here
                if (classificationDescription === OrderStatusDescriptionEnum.Available) {
                    return [tm.Get("Received"), ThemeColorEnum.Primary];
                } else if (classificationDescription === OrderStatusDescriptionEnum.Uploaded) {
                    return [tm.Get("In Process"), ThemeColorEnum.Primary];
                }
            }

            // Viewing a contractor created quote (for end customer) that was submitted
            if (quote.isSubmitted && !quote.contractorOrderNumber) {
                //We do not want to show available here since it is readonly (already submitted)
                if (classificationDescription === OrderStatusDescriptionEnum.Available) {
                    return ["", ThemeColorEnum.Primary];
                }
            }

            const label = Constants.Strings.Classifications.includes(classificationDescription) ? tm.Get(classificationDescription) : classificationDescription;

            switch (quote.status) {
                case OrderStatusEnum.OnHold:
                    return [label, ThemeColorEnum.Warning];
                case OrderStatusEnum.Uploaded:
                    return [label, ThemeColorEnum.Primary];
                default:
                    return [label, ThemeColorEnum.Success];
            }
        }
        return ["", ThemeColorEnum.Primary];
    }, [quote, quoteClassifications, isContractor, tm]);

    if (isNullOrWhiteSpace(chipLabel)) {
        return <></>;
    }

    return <Chip
        label={chipLabel}
        color={chipColor}
    />
}

export default StatusChip;